import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'cms-article-detail',
  name: '图文详情',
  icon: '详',
  group: 'CMS通用',
  description: '展示图文内容详情，含标题、作者、正文、图片、视频等。',
  defaultProps: {
    showTitle: true,
    showAuthor: true,
    showPublishedAt: true,
    showSummary: true,
    showCover: true
  }
}
